import "@arco-design/web-react/es/Modal/style";
import _Modal from "@arco-design/web-react/es/Modal";
import "@arco-design/web-react/es/Space/style";
import _Space from "@arco-design/web-react/es/Space";
import "@arco-design/web-react/es/Button/style";
import _Button from "@arco-design/web-react/es/Button";
import "@arco-design/web-react/es/Link/style";
import _Link from "@arco-design/web-react/es/Link";
import "@arco-design/web-react/es/Checkbox/style";
import _Checkbox from "@arco-design/web-react/es/Checkbox";
import _IconLock from "@arco-design/web-react/icon/react-icon/IconLock";
import "@arco-design/web-react/es/Input/style";
import _Input from "@arco-design/web-react/es/Input";
import _IconEmail from "@arco-design/web-react/icon/react-icon/IconEmail";
import _IconSunFill from "@arco-design/web-react/icon/react-icon/IconSunFill";
import _IconMoonFill from "@arco-design/web-react/icon/react-icon/IconMoonFill";
import "@arco-design/web-react/es/Radio/style";
import _Radio from "@arco-design/web-react/es/Radio";
import "@arco-design/web-react/es/Message/style";
import _Message from "@arco-design/web-react/es/Message";
import "@arco-design/web-react/es/Form/style";
import _Form from "@arco-design/web-react/es/Form";

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React, { useEffect, useRef, useState, useContext } from 'react';
import axios from 'axios';
import useStorage from '@/utils/useStorage';
import useLocale from '@/utils/useLocale';
import locale from './locale';
import styles from './style/index.module.less';
import { GlobalContext } from '@/context';
import IconButton from '@/components/NavBar/IconButton';
import defaultLocale from '@/locale';
export default function LoginForm() {
  const formRef = useRef();
  const [loading, setLoading] = useState(false);
  const [loginParams, setLoginParams, removeLoginParams] = useStorage('loginParams');
  const {
    setLang,
    lang,
    theme,
    setTheme
  } = useContext(GlobalContext);
  const t = useLocale(locale);
  const [rememberPassword, setRememberPassword] = useState(!!loginParams);
  const [visible, setVisible] = useState(false);
  const [confirmLoading, setConfirmLoading] = useState(false);

  const [formForget] = _Form.useForm();

  const formItemLayout = {
    labelCol: {
      span: 4
    },
    wrapperCol: {
      span: 20
    }
  };

  function afterLoginSuccess(params) {
    // 记住密码
    if (rememberPassword) {
      setLoginParams(JSON.stringify(params));
    } else {
      removeLoginParams();
    } // 记录登录状态


    localStorage.setItem('userStatus', 'login');
    const url = localStorage.getItem('redirectUrl'); // 跳转首页

    window.location.href = url != '' && url != null && url != undefined ? url : '/home';
  }

  function login(params) {
    setLoading(true);
    axios.post('/api/login', params).then(res => {
      if (res && res.data) {
        if (res.status === 200) {
          afterLoginSuccess(params);
          localStorage.setItem('token', res.data.access_token);
          localStorage.setItem('refresh_token', res.data.refresh_token);
        }
      } else {
        _Message.error({
          content: t['login.form.login.errMsg'],
          showIcon: true,
          position: 'top'
        });
      }
    }).catch(err => {
      console.log(err);
    }).finally(() => {
      setLoading(false);
    });
  }

  function onSubmitClick() {
    formRef.current.validate().then(values => {
      console.log(values);
      login(values);
    });
  }

  function onRegisterClick() {
    window.location.pathname = '/register';
  }

  async function onOk() {
    try {
      await formForget.validate(['email']);
      formForget.validate().then(res => {
        setConfirmLoading(true);
        axios.post('/api/reset_password_send_code', res).then(res => {
          if (res) {
            _Message.success({
              content: t['login.form.reset.success'],
              showIcon: true,
              position: 'top'
            });

            setVisible(false);
            setConfirmLoading(false);
          } else {
            _Message.error({
              content: 'error',
              showIcon: true,
              position: 'top'
            });

            setVisible(false);
            setConfirmLoading(false);
          }
        }).catch(err => {
          console.log(err);
          setVisible(false);
          setConfirmLoading(false);
        }).finally(() => {
          setVisible(false);
          setConfirmLoading(false);
        });
      });
    } catch (e) {// Message.error('Email 校验失败');
    }
  } // 读取 localStorage，设置初始值


  useEffect(() => {
    const rememberPassword = !!loginParams;
    setRememberPassword(rememberPassword);

    if (formRef.current && rememberPassword) {
      const parseParams = JSON.parse(loginParams);
      formRef.current.setFieldsValue(parseParams);
    }
  }, [loginParams]);
  return /*#__PURE__*/React.createElement("div", {
    className: styles['login-form-wrapper']
  }, /*#__PURE__*/React.createElement("div", {
    className: styles['login-form-title']
  }, t['login.form.title']), /*#__PURE__*/React.createElement("div", {
    className: styles['login-form-sub-title']
  }, t['login.form.title']), /*#__PURE__*/React.createElement("div", {
    className: styles['login-form-buttons']
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(_Radio.Group, {
    type: "button",
    name: "lang",
    defaultValue: lang,
    style: {
      marginRight: 20,
      marginBottom: 20
    },
    onChange: value => {
      setLang(value);
      const nextLang = defaultLocale[value];

      _Message.info(`${nextLang['message.lang.tips']}${value}`);
    }
  }, /*#__PURE__*/React.createElement(_Radio, {
    value: "zh-CN"
  }, "\u4E2D\u6587"), /*#__PURE__*/React.createElement(_Radio, {
    value: "en-US"
  }, "English"))), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(IconButton, {
    icon: theme !== 'dark' ? /*#__PURE__*/React.createElement(_IconMoonFill, null) : /*#__PURE__*/React.createElement(_IconSunFill, null),
    onClick: () => setTheme(theme === 'light' ? 'dark' : 'light')
  }))), /*#__PURE__*/React.createElement(_Form, {
    className: styles['login-form'],
    layout: "vertical",
    ref: formRef
  }, /*#__PURE__*/React.createElement(_Form.Item, {
    field: "email",
    rules: [{
      required: true,
      message: t['login.form.email.errMsg']
    }]
  }, /*#__PURE__*/React.createElement(_Input, {
    prefix: /*#__PURE__*/React.createElement(_IconEmail, null),
    placeholder: t['login.form.email.placeholder'],
    onPressEnter: onSubmitClick
  })), /*#__PURE__*/React.createElement(_Form.Item, {
    field: "password",
    rules: [{
      required: true,
      message: t['login.form.password.errMsg']
    }]
  }, /*#__PURE__*/React.createElement(_Input.Password, {
    prefix: /*#__PURE__*/React.createElement(_IconLock, null),
    placeholder: t['login.form.password.placeholder'],
    onPressEnter: onSubmitClick
  })), /*#__PURE__*/React.createElement(_Space, {
    size: 16,
    direction: "vertical"
  }, /*#__PURE__*/React.createElement("div", {
    className: styles['login-form-password-actions']
  }, /*#__PURE__*/React.createElement(_Checkbox, {
    checked: rememberPassword,
    onChange: setRememberPassword
  }, t['login.form.rememberPassword']), /*#__PURE__*/React.createElement(_Link, {
    onClick: () => setVisible(true)
  }, t['login.form.forgetPassword'])), /*#__PURE__*/React.createElement(_Button, {
    type: "primary",
    long: true,
    onClick: onSubmitClick,
    loading: loading
  }, t['login.form.login']), /*#__PURE__*/React.createElement(_Button, {
    type: "text",
    long: true,
    onClick: onRegisterClick,
    className: styles['login-form-register-btn']
  }, t['login.form.register']))), /*#__PURE__*/React.createElement(_Modal, {
    title: t['login.form.forgetPassword'],
    visible: visible,
    onOk: onOk,
    confirmLoading: confirmLoading,
    onCancel: () => setVisible(false)
  }, /*#__PURE__*/React.createElement(_Form, _extends({}, formItemLayout, {
    form: formForget,
    labelCol: {
      style: {
        flexBasis: 90
      }
    },
    wrapperCol: {
      style: {
        flexBasis: 'calc(100% - 90px)'
      }
    }
  }), /*#__PURE__*/React.createElement(_Form.Item, {
    label: "Email",
    field: "email",
    rules: [{
      type: 'email',
      required: true
    }]
  }, /*#__PURE__*/React.createElement(_Input, {
    placeholder: ""
  })))));
}